import { Dispatch } from 'react';
import { LSTORAGE_KEY } from 'src/constants';
import { IStoreState } from 'src/interface';
import { Logger, LocalStore } from 'src/utils';
import { isBookmarkSeclector, isFollowSeclector } from 'src/selectors/user';
import UserService from 'src/services/UserService';
import * as dispatchActions from './dispatchActions';

const getLocalLikeAsset = (): number[] | null => {
    return LocalStore.get(LSTORAGE_KEY.CONTENTS_LIKE);
};

export const loadAssetsUser = () => async (dispatch: Dispatch<any>) => {
    UserService.getUserAssets()
        .then((resp) => {
            if (resp.data) {
                const like = getLocalLikeAsset();
                const user = {
                    ...resp.data,
                    like,
                };
                dispatch(dispatchActions.updateUserAssets(user));
            }
        })
        .catch((err) => {
            if (err) {
                Logger.error(
                    err.err,
                    'get user Assets fail |',
                    err,
                    'authState | ',
                    (window as any).authState
                );
            }
        });
};

export const follow = (objectType: string, objectId: number) => {
    return async (dispatch: Dispatch<any>, getState: () => IStoreState) => {
        const state = getState();
        const isFollow = isFollowSeclector(objectType, objectId)(state);

        UserService.follow(objectType, objectId, isFollow)
            .then((resp) => {
                dispatch(dispatchActions.follow(objectType, objectId));
            })
            .catch((resp) => {
                Logger.error(resp?.err, 'follow err ', resp);
            });
    };
};

export const bookmark = (id: number) => {
    return async (dispatch: Dispatch<any>, getState: () => IStoreState) => {
        const isBookmark = isBookmarkSeclector(id)(getState());

        UserService.bookmark(id, isBookmark)
            .then((resp) => {
                dispatch(dispatchActions.bookmark(id));
            })
            .catch((resp: any) => {
                Logger.error(resp?.err, 'bookmark fail err ', resp);
            });
    };
};

export const like = (id: number) => {
    return async (dispatch: Dispatch<any>, getState: () => IStoreState) => {
        try {
            const state = getState();
            await UserService.like({
                userId: state.auth.userId,
                id,
            });
            dispatch(dispatchActions.like(id));
        } catch (err) {
            Logger.error('', 'like fail ', err);
        }
    };
};